import { render } from "./HelpModule.vue?vue&type=template&id=dd9df8e8&scoped=true"
import script from "./HelpModule.vue?vue&type=script&lang=js"
export * from "./HelpModule.vue?vue&type=script&lang=js"

import "./HelpModule.vue?vue&type=style&index=0&id=dd9df8e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9df8e8"]])

export default __exports__